import { Button, Modal, Space } from 'antd'
import { MdOutlineContentCopy, MdOutlineFileDownload } from 'react-icons/md'

import { JsonViewer } from '@/Core/Components/Debug/components/JsonViewer'
import { notify } from '@/Ship/Helpers/notify'

import { formatRequest, parseRequest, requestFileName } from '../Helpers/exchangePayload'

interface RequestModalProps {
    /** Запис журналу; null — вікно закрите */
    record: Record<string, any> | null
    onClose: () => void
}

const downloadRequest = (record: Record<string, any>) => {
    const blob = new Blob([formatRequest(record['request'])], { type: 'application/json' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = requestFileName(record)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
}

const copyRequest = (record: Record<string, any>) => {
    navigator.clipboard
        .writeText(formatRequest(record['request']))
        .then(() => notify.success('Запит скопійовано'))
        .catch(() => notify.error('Не вдалося скопіювати'))
}

/** Вікно з тілом запиту до ERP: перегляд JSON з пошуком, копіювання, завантаження файлом */
export const RequestModal = ({ record, onClose }: RequestModalProps) => (
    <Modal
        open={record !== null}
        title={record ? `Запит #${record['id']} — ${record['entityType'] ?? ''}` : 'Запит'}
        width={720}
        onCancel={onClose}
        destroyOnHidden
        footer={
            <Space>
                <Button icon={<MdOutlineContentCopy />} onClick={() => record && copyRequest(record)}>
                    Копіювати все
                </Button>
                <Button
                    type="primary"
                    icon={<MdOutlineFileDownload />}
                    onClick={() => record && downloadRequest(record)}
                >
                    Завантажити
                </Button>
            </Space>
        }
    >
        {record && <JsonViewer data={parseRequest(record['request'])} showSearch defaultExpandLevel={3} />}
    </Modal>
)
